<template>
  <div class="child-settings-panels-item"
       :class="{ 'constricted': constricted }">
    <div class="child-info">
      <router-link :to="childRoute"
              class="child-name"
              active-class="active"
              v-if="child">
        <child-avatar :child="child"
                      class="child-info__avatar"
                      show-out-of-sync
                      out-of-sync-position="right"
                      size="small" />

        <div class="one-liner">
          {{ child.name }}
        </div>
      </router-link>

      <location-status class="location-status"
                       :show-title="true"
                       :child="child" />
    </div>

    <div v-if="devices.length"
         class="child-settings">
      <screen-time-card class="item-margin"
                        size="mobile"
                        :child-id="child.id" />

      <device-availability-card class="item-margin"
                                size="mobile"
                                :child-id="child.id" />

      <device-availability-label :child-id="child.id" />

      <device-unrestricted-label :child-id="child.id" />

      <child-settings-panels-status :child-id="child.id"/>
    </div>

    <no-device-placeholder v-else
                           class="no-device"
                           :showIcon="true" />
  </div>
</template>

<script>
  import DeviceAvailabilityLabel from '@/components/Child/ChildDeviceAvailability/DeviceAvailabilityLabel.vue'
  import DeviceUnrestrictedLabel from '@/components/Child/ChildDeviceAvailability/DeviceUnrestrictedLabel.vue'
  import ScreenTimeCard from '@/components/Child/ChildScreenTime/ScreenTimeCard.vue'
  import DeviceAvailabilityCard from '@/components/Child/ChildDeviceAvailability/DeviceAvailabilityCard'
  import ChildSettingsPanelsStatus from './ChildSettingsPanelsStatus.vue'
  import NoDevicePlaceholder from './ChildSettingsPanelsNoDevice.vue'
  import LocationStatus from '@/components/Common/LocationStatus'
  import ChildAvatar from '@/components/Child/ChildAvatar.vue'

  import { localEventTime, localEventDate } from '@/services/localTime'

  export default {
    props: {
      child: {
        required: true,
        type: Object
      },

      constricted: {
        required: false,
        type: Boolean,
        default: false
      }
    },

    components: {
      DeviceAvailabilityLabel,
      DeviceUnrestrictedLabel,
      ScreenTimeCard,
      DeviceAvailabilityCard,
      ChildSettingsPanelsStatus,
      NoDevicePlaceholder,
      LocationStatus,
      ChildAvatar
    },

    computed: {
      childRoute() {
        return {
          name: 'children.single',
          params: {
            id: this.child.id
          }
        }
      },

      itemClasses() {
        return {
          'constricted': this.constricted,
          'child-settings-panels-item-mobile': this.$mq === 'mobile'
        }
      },

      lastSeen() {
        return `${localEventDate(this.child.status.last_seen)} ${localEventTime(this.child.status.last_seen)}`
      },

      devices() {
        return this.child.devices
      },

      mode() {
        return this.child.modes.find(mode => mode.id === this.child.current_rule.mode_id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-settings-panels-item {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    min-height: 242px;
    width: 320px;
    padding: 15px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 4px 0 rgba(#000, .1);

    &.constricted {
      padding: 15px 0 20px;
      box-shadow: none;
    }
  }

  .child-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    color: #3e3a3b;

    .child-name {
      min-width: 0;

      display: flex;
      align-items: center;
    }

    .location-status {
      font-size: 11px;
    }

    &__avatar {
      flex-shrink: 0;
      margin-right: 8px;
    }
  }

  .item-margin {
    margin-bottom: 10px;
  }

  .unavailable-warning {
    font-size: 12px;
    color: #F35D5D;
    font-weight: bold;
    margin-bottom: 15px;

    .icon {
      position: relative;
      bottom: -3px;
      margin-right: 5px;
    }
  }
</style>
